<template>
  <div
    v-if="options"
    :class="[
      'grid-filter switch',
      {'is-clear': isClear},
      options.classes,
      `field-${config.field}`
    ]"
    :style="options.styles">
    <el-form-item
      class="material-style"
    >
      <el-switch
        class="small"
        v-model="model"
        @input="handleChangeDebounce"
        :active-color="options.active.color"
        :inactive-color="options.inactive.color"
        :active-text="activeLabel"
        :inactive-text="inactiveLabel">
      </el-switch>
    </el-form-item>
  </div>
</template>

<script>
import mixins from '../mixins'

export default {
  name: 'FilterSwitch',
  mixins: [mixins],
  props: {
    config: { type: Object },
    place: { type: String, default: 'column' }
  },
  data () {
    return {
      model: ''
    }
  },
  computed: {
    isClear () {
      return !(this.model)
    },
    activeLabel () {
      return this.checkEs6AndRun(this.options.active.label)
    },
    inactiveLabel () {
      return this.checkEs6AndRun(this.options.inactive.label)
    }
  },
  created () {
    this.handleChangeDebounce = this.$_.debounce(this.handleChange, 500)
  },
  methods: {
    MODEL () {
      return {
        // eslint-disable-next-line
        field: '',
        value: '',
        // eslint-disable-next-line
        valueTemplate: '${data.field}==${data.value}',
        // style
        classes: '',
        styles: { minWidth: '10rem' },
        active: {
          value: true,
          color: '#06aaea',
          // eslint-disable-next-line
          label: '${root.L10n("true")}'
        },
        inactive: {
          value: false,
          color: 'grey',
          // eslint-disable-next-line
          label: '${root.L10n("false")}'
        },
        size: ''
      }
    },
    parseConfig (Options) {
      this.handle('parseStart')
      // update options
      this.options = this.$_.merge(this.MODEL(), this.config.options, Options || {})
      this.model = this.options.value
      this.parseOptionsTemplate()
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      // update model
      // TODO: NOTE#1 In next version need parse value from ARRAY and String
      // this.setValue(this.options.value, true)
      this.handle('init')
      this.setDefaultValue()
    },
    handleChange () {
      this.updateRendered()
      this.handle('change')
    },
    updateRendered () {
      this.result = this.options.value
      this.resultHuman = ''
      if (this.model) {
        this.result = this.valueTemplate({ field: this.config.field, value: this.model }, this)
        this.resultHuman = this.model
      } else if (this.options.value) {
        // TODO: NOTE#1 In next version need parse value from ARRAY and String
        // this.resultHuman = this.getOriginValue(this.options.value)
      }
    },

    // TODO: Public methods
    clear () {
      this.model = this.options.value = false
      this.updateRendered()
      this.handle('change')
    },
    /**
     * @name resetField
     * @desc Method for reset field data. It emits, when user click button 'clear-filter'
     */
    resetField () {
      this.model = this.options.value = false
      this.updateRendered()
      this.handle('resetField')
    },
    setValue (Val, runAnyway = false) {
      if (this.options && (this.options.value !== Val || runAnyway)) {
        this.options.value = Val
        this.model = this.getOriginValue(Val)
        this.updateRendered()
      }
    },
    handle (Type) {
      this.$emit('handle', {
        id: this.config.id,
        type: Type,
        value: this.result,
        rendered: this.resultHuman
      })
    }
  }
}
</script>
